<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'词条列表管理'" />
    <StatisticalPanel
      :whichModule="'entries'"
      :data="overallData"
    ></StatisticalPanel>
    <ModuleClassfication
      :title="titles"
      class="pc-news-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <div class="pc-university-table">
      <EntryTable />
    </div>
  </div>
</template>
<script>
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import ModuleClassfication from "@/components/componentSet/ModuleClassfication";
import EntryTable from "../entry/components/EntryTable";

import {
  entryCount_Api,
  entryClassificationSearch_Api,
  createEntryClassification_Api,
  updateEntryClassification_Api,
  deleteEntryClassification_Api,
} from "../../../apis/entry.api";
export default {
  components: {
    BreadCrumb,
    EntryTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "词条列表", link: "/admin/entryList" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "词条数据",
        count: [{ name: "词条数量", count: null }],
      },
      titles: {
        module: "词条",
        class: [{ name: "Classification", subTitles: [] }],
      },
      count: 0,
    };
  },
  mounted() {
    entryCount_Api().then((res) => {
      console.log(res.data);
      this.$set(this.overallData.count[0], "count", res.data.count);
    });
    this.entryListSearch();
  },
  methods: {
    updateTopic(topic, callback) {
      updateEntryClassification_Api({
        chinese_name: topic.chinese_name,
        english_name: topic.english_name,
        classification_id: topic.id,
        status: topic.status,
      }).then(() => {
        callback();
        this.entryListSearch();
      });
    },
    addTopic(topic, callback) {
      console.log(topic);
      createEntryClassification_Api({
        chinese_name: topic.chinese_name,
        english_name: topic.english_name,
        status: topic.status,
      }).then(() => {
        callback();
        this.entryListSearch();
      });
    },
    deleteTopic(topic, callback) {
      deleteEntryClassification_Api({
        classification_id: topic.id,
      }).then(() => {
        callback();
        this.entryListSearch();
      });
    },
    entryListSearch() {
      entryClassificationSearch_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/entry/EntryList.vue